import React from 'react'
import { FormGroup } from '@smooth-ui/core-em'
import { Grid, Typography, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import LocationAutoComplete from 'components/LocationAutoComplete'
import Button from 'components/ButtonMaterial'
import pick from 'lodash.pick'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { showFlashMessage, showFlashMessageOnUnexpectedError, updateUser, updateUserAvatar } from 'actions'
import isempty from 'lodash.isempty'
import { css } from 'react-emotion'
import profileImg from 'images/svg/profile.svg'
import ClearIcon from '@material-ui/icons/Clear'
import { EMAIL_REGEX, PHONE_REGEX, ZIP_REGEX } from '../../../constants'

const styles = theme => ({
  grid: {
    marginBottom: '30px',
  },
  gridPadding: {
    paddingLeft: '2%',
  },
  profileImage: {
    width: '100%',
    borderRadius: '50%',
  },
  form: {
    width: '100%',
  },
  textFieldFirstName: {
    marginRight: '2%',
    width: '48%',
    '& > label': {
      textTransform: 'uppercase',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginRight: '0',
    },
  },
  textFieldSecondName: {
    width: '50%',
    '& > label': {
      textTransform: 'uppercase',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  textFieldFullWidth: {
    marginLeft: '2%',
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'black',
    },
  },
  cssLabelError: {
    '&$cssFocused': {
      color: 'red',
    },
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#00bcb5',
    },
  },
  updateBtn: {
    width: '40%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  changeImageBtn: {
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      width: '26%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '41%',
    },
    height: '33px',
  },
  //the idea is to hide the input, but to have it in the DOM so we can use it as ref
  fileInput: {
    fontSize: '100px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    top: '0',
    left: '0',
    width: '0.1px',
    height: '0.1px',
  },
})
const removeLocationIcon = css({
  position: 'absolute',
  top: 0,
  transform: 'translate(0,75%)',
  right: '6px',
  color: '#cacac1',
  cursor: 'pointer',
  fontSize: 'large!important',
  marginLeft: '1em',
})

const termsConditionslink = css({
  color: '#00bcb5',
  textDecoration: 'none',
  '&:hover': {
    cursor: 'pointer',
  },
})

const disabledClass = css({
  color: 'rgba(0,0,0,0.26)',
})

const userFields = ['firstName', 'lastName', 'email', 'phone', 'locations', 'zip']

class InvestorProfile extends React.Component {
  constructor(props) {
    super(props)
    this.state = userFields.reduce((output, field) => ({ ...output, [field]: '' }), { errors: {}, imgError: false })

    this.fileInput = null

    this.setFileInputRef = element => {
      this.fileInput = element
    }
  }

  componentDidMount() {
    this.MAX_LOCATIONS = 6
    const reducer = (data, field) => {
      if (this.props.user.personalData.get(field)) {
        if (field === 'locations') {
          const loc = this.props.user.personalData
            .get(field)
            .toArray()
            .map((v, i) => ({ location: v, id: i }))
          if (loc.length === 0) loc.push({ location: '', id: 1 })
          data['locations'] = loc
        } else {
          data[field] = this.props.user.personalData.get(field)
        }
      }
      return data
    }

    this.setState(userFields.reduce(reducer, {}))
    this.setState(state => ({
      errors: {
        ...state.errors,
        locations: this.props.user.personalData
          .get('locations')
          .toArray()
          .map(_ => null),
      },
    }))
  }

  onFormFieldChange = event => {
    const target = event.target
    const name = target.id
    const value = target.value
    this.setState(state => ({
      [name]: value,
      errors: { ...state.errors, [name]: this.validateField(name, value) },
    }))
  }

  validateField = (name, value, isLocation, index) => {
    if (isLocation) {
      const loc = this.state.locations[index]
      if (loc.location === '') {
        return 'is missing'
      } else if (loc.location === null || loc.location === undefined) {
        return 'is invalid'
      }
    }
    if (value === '') {
      return 'is missing'
    } else if (value === null || value === undefined) {
      return 'is invalid'
    }

    switch (name) {
      case 'firstName':
      case 'lastName':
      case 'location': {
        if ('' === value.trim()) {
          return 'is invalid'
        }
        break
      }
      case 'zip': {
        if (null === value.match(ZIP_REGEX)) {
          return 'is invalid'
        }
        break
      }
      case 'email': {
        if (!value.match(EMAIL_REGEX)) {
          return 'is invalid'
        }
        break
      }
      case 'phone': {
        if (!value.match(PHONE_REGEX) || value.length < 9) {
          return 'is invalid'
        }
        break
      }
      default:
        break
    }
  }

  isValid = () => {
    return userFields.reduce(
      (a, f) => a && this.state[f] && (f !== 'locations' ? !this.state.errors[f] : this.state.errors[f].filter(er => er || er === '').length === 0),
      true
    )
  }

  handleSubmit = async event => {
    event.preventDefault()
    if (this.isValid()) {
      try {
        const dataToBeUpdated = pick(this.state, userFields)
        dataToBeUpdated.locations = this.state.locations.map(loc => loc.location)

        for (var key in dataToBeUpdated) {
          if (key !== 'locations') {
            dataToBeUpdated[key] = dataToBeUpdated[key].trim()
          }
        }

        const response = await this.props.updateUser(dataToBeUpdated, this.props.user.token)

        if (isempty(response.errors)) {
          this.props.handleClose()
          this.props.showFlashMessage(null, `Your profile has been updated successfully!`)
        } else {
          this.props.showFlashMessage(true, response.errors.map(field => `${field[0]} ${field[1].join(', ')}`).join(';'))
        }
      } catch (error) {
        this.props.showFlashMessageOnUnexpectedError(error)
      }
    }
  }

  handleLocationSelect = (location, placeID, index = 0) => {
    // placeID is null when user press Enter Key and doesnt select a value
    const error = this.validateField('location', placeID, true, index)
    const locationErrors =
      this.state.errors.locations.length === 0 ? [error] : this.state.errors.locations.map((locError, i) => (i === index ? error : locError))
    this.setState(state => ({
      location,
      errors: { ...state.errors, locations: locationErrors },
      locations: state.locations.map((loc, i) => (i === index ? { ...loc, location } : loc)),
    }))
  }
  handleRemoveAvatar = async event => {
    event.preventDefault()
    try {
      const response = await this.props.updateUserAvatar(null, this.props.user.token)
      if (!isempty(response.errors)) {
        this.props.showFlashMessageOnUnexpectedError(response.errors)
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error)
    }
  }

  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.addEventListener('load', () => this.props.onImageUpload(reader.result))
      reader.readAsDataURL(e.target.files[0])
    }
  }

  onChangeImageClick = () => {
    // Focus the text input using the raw DOM API
    if (this.fileInput && !this.props.user.personalData.get('avatarUrl')) {
      this.fileInput.click()
    } else {
      this.props.onImageChange()
    }
  }

  imgError = event => {
    const image = event.target
    image.onerror = ''
    image.src = profileImg
    this.setState({
      imgError: true,
    })
  }
  removeLocation(idx) {
    if (this.state.locations.length <= 1) return
    this.setState(state => {
      return {
        locations: state.locations.filter((_, index) => index !== idx),
        errors: { ...state.errors, locations: state.errors.locations.filter((_, index) => index !== idx) },
      }
    })
  }

  addMoreLocation() {
    if (this.state.locations.length >= this.MAX_LOCATIONS) return
    this.setState(state => {
      return {
        locations: state.locations.concat([{ location: '', id: state.locations.length }]),
        errors: { ...state.errors, locations: state.errors.locations.concat('') },
      }
    })
  }

  render() {
    const { firstName, lastName, locations, zip, phone, email, errors, imgError } = this.state
    const {
      classes,
      user: { personalData },
    } = this.props
    const savedPhone = personalData.get('phone')
    const savedEmail = personalData.get('email')
    const avatarUrl = personalData.get('avatarUrl')
      ? personalData.get('avatarUrl').indexOf('homevestors') > -1
        ? `${personalData.get('avatarUrl')}?${new Date().getTime()}`
        : personalData.get('avatarUrl')
      : profileImg

    const labelProps = {
      shrink: true,
      FormLabelClasses: {
        root: classes.cssLabel,
        focused: classes.cssFocused,
        error: classes.cssLabelError,
      },
    }
    return (
      <Grid item>
        <Grid item className={classes.grid}>
          <Typography gutterBottom>{savedEmail}</Typography>
          <Typography>{savedPhone}</Typography>
        </Grid>
        <Grid container>
          <Grid item xs={2}>
            <img src={avatarUrl} alt={'profile'} className={classes.profileImage} onError={this.imgError} />
          </Grid>
          <Grid xs={10} item container direction="column" className={classes.gridPadding}>
            <Grid item>
              <Button small className={classes.changeImageBtn} onClick={this.onChangeImageClick}>
                {avatarUrl ? 'Change Image' : 'Upload Image'}
              </Button>
              {/* will be hidden by css */}
              <input type="file" className={classes.fileInput} onChange={this.onSelectFile} ref={this.setFileInputRef} accept="image/x-png,image/jpeg" />
            </Grid>
            <Grid item>
              <Button link onClick={this.handleRemoveAvatar} disabled={!avatarUrl || avatarUrl === profileImg || imgError}>
                Remove
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container>
          <form noValidate autoComplete="off" className={classes.form}>
            <Grid item className={classes.grid}>
              <TextField
                id="firstName"
                label="First name"
                className={classes.textFieldFirstName}
                value={firstName}
                margin="normal"
                InputLabelProps={labelProps}
                InputProps={{
                  classes: {
                    underline: classes.cssUnderline,
                  },
                  inputProps: {
                    maxLength: 40,
                  },
                }}
                error={errors.firstName ? true : false}
                helperText={errors.firstName}
                onChange={this.onFormFieldChange}
              />
              <TextField
                id="lastName"
                label="Last Name"
                className={classes.textFieldSecondName}
                value={lastName}
                margin="normal"
                InputLabelProps={labelProps}
                InputProps={{
                  classes: {
                    underline: classes.cssUnderline,
                  },
                  inputProps: {
                    maxLength: 80,
                  },
                }}
                error={errors.lastName ? true : false}
                helperText={errors.lastName}
                onChange={this.onFormFieldChange}
              />
              <TextField
                id="email"
                label="EMAIL"
                value={email}
                margin="normal"
                fullWidth
                InputLabelProps={labelProps}
                InputProps={{
                  classes: {
                    underline: classes.cssUnderline,
                  },
                  inputProps: {
                    maxLength: 80,
                  },
                }}
                error={errors.email ? true : false}
                helperText={errors.email}
                onChange={this.onFormFieldChange}
              />
              <TextField
                id="phone"
                label="PHONE"
                value={phone}
                margin="normal"
                fullWidth
                InputLabelProps={labelProps}
                InputProps={{
                  classes: {
                    underline: classes.cssUnderline,
                  },
                  inputProps: {
                    maxLength: 40,
                  },
                }}
                error={errors.phone ? true : false}
                helperText={errors.phone}
                onChange={this.onFormFieldChange}
              />
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '440px' }}>
                {locations &&
                  locations.map((loc, indx) => (
                    <div key={`loc100_${indx}`} style={{ position: 'relative', maxWidth: '210px', display: 'inline-block', marginRight: '.5em' }}>
                      <FormGroup>
                        <LocationAutoComplete
                          index={indx}
                          className={classes.textFieldFullWidth}
                          from="profile"
                          location={loc.location}
                          formFieldChange={this.onFormFieldChange}
                          locationSelection={(newLoc, placeId) => this.handleLocationSelect(newLoc, placeId, indx)}>
                          <TextField
                            fullWidth
                            margin="normal"
                            InputLabelProps={labelProps}
                            InputProps={{
                              classes: {
                                underline: classes.cssUnderline,
                              },
                            }}
                            error={errors.locations[indx] ? true : false}
                            helperText={errors.locations[indx]}
                          />
                        </LocationAutoComplete>
                        <ClearIcon onClick={() => this.removeLocation(indx)} className={removeLocationIcon} />
                      </FormGroup>
                    </div>
                  ))}
              </div>
              <div className={`${termsConditionslink} ${locations.length === this.MAX_LOCATIONS && disabledClass}`}>
                <p onClick={this.addMoreLocation.bind(this)}>+ Add another location</p>
              </div>
              <TextField
                id="zip"
                label="ZIPCODE"
                value={zip}
                margin="normal"
                fullWidth
                InputLabelProps={labelProps}
                InputProps={{
                  classes: {
                    underline: classes.cssUnderline,
                  },
                }}
                error={errors.zip ? true : false}
                helperText={errors.zip}
                onChange={this.onFormFieldChange}
              />
            </Grid>
            <Grid item align="right">
              <Button className={classes.updateBtn} onClick={this.handleSubmit} disabled={!this.isValid()}>
                Update
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
    )
  }
}

InvestorProfile.propTypes = {
  classes: PropTypes.object,
  onImageUpload: PropTypes.func.isRequired,
  onImageChange: PropTypes.func.isRequired,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFlashMessage,
      showFlashMessageOnUnexpectedError,
      updateUser,
      updateUserAvatar,
    },
    dispatch
  )
}

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(InvestorProfile)
)



// WEBPACK FOOTER //
// ./src/features/investorDashboard/components/InvestorProfile.js